import { render } from "./KoruProgress.vue?vue&type=template&id=4bd8c46a&ts=true"
import script from "./KoruProgress.vue?vue&type=script&lang=ts"
export * from "./KoruProgress.vue?vue&type=script&lang=ts"

import "./KoruProgress.vue?vue&type=style&index=0&id=4bd8c46a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__